export default __webpack_public_path__ + "static/hero-b010bc581ba5a808805a052e954ce54e.png";